// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1db47144","594":"8bbf757f"}[chunkId] + ".chunk.js";
};